import React, { useState, useEffect } from "react";

import SlideMainTitle from "../slides-components/Title";
import TitleDescription from "../slides-components/TitleDescription";
import SlideWrapper from "../slides-components/SlideWrapper";

const slideData = {
  title: "Hai un contratto di lavoro dipendente full-time?",
  options: ["si", "no"],
};

const SlideFullTime = ({ urlParameters, navigate, queryString }) => {
  const [whichActive, setWhichActive] = useState(null);

  useEffect(() => {
    if (whichActive !== null) {
      const newQueries = {
        ...urlParameters,
        currentStep: parseInt(urlParameters.currentStep) + 1,
        fullTime: slideData.options[whichActive] === "si" ? 1 : 0,
      };
      navigate("/calcolatore/?" + queryString.stringify(newQueries));
    }
  }, [whichActive, navigate, queryString, urlParameters]);

  return (
    <SlideWrapper>
      <div className="text-center mb-8">
        <SlideMainTitle text={slideData.title} />
        <TitleDescription
          text={
            " Sei considerato un dipendente full-time se fai più di 32 ore settimanali"
          }
        />
      </div>
      <div className="flex flex-row gap-x-2">
        {slideData.options.map((option, index) => {
          return (
            <button
              key={`choice-btn-${index}`}
              className={`${
                whichActive === index && "selected"
              } default w-[100px] h-[100px] md:w-[200px] md:h-[200px] text-2xl`}
              onClick={() => {
                setWhichActive(index);
              }}
            >
              {option}
            </button>
          );
        })}
      </div>
    </SlideWrapper>
  );
};

export default SlideFullTime;
